module.exports = __webpack_public_path__ + "img/7_195.584dccd5.png";